import React, { useEffect, useState } from "react";
import { FaToggleOn, FaToggleOff } from "react-icons/fa6";
import { toast } from "react-toastify";
import { API_tecnicos } from "../../config/apiConfig";
import "./../../pages/user/css/Perfil.css";
import { useAuth } from "../../context/AuthContext";

const ActivarDesactivarTecnicos = ({ status, id }) => {
  const [activo, setActivo] = useState(null);
  const { token } = useAuth();
  useEffect(() => {
    if (typeof status === "string") {
      setActivo(status.toLowerCase() === "activo");
    }
  }, [status]);

  const actualizarEstado = async (nuevoEstado) => {
    if (!id) {
      toast.error("No se encontró el ID del técnico");
      return;
    }

    try {
      const res = await fetch(`${API_tecnicos}/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", "x-auth-token": token },
        body: JSON.stringify({
          employeeStatus: nuevoEstado ? "Activo" : "Inactivo",
        }),
      });

      if (!res.ok) throw new Error();

      setActivo(nuevoEstado);
      toast.success("Estado actualizado correctamente");
    } catch (err) {
      console.error("Error al actualizar estado:", err);
      toast.error("No se pudo cambiar el estado");
    }
  };

  const handleToggle = () => actualizarEstado(!activo);

  if (activo === null) return null;

  return (
    <div className="activar column gap-30">
      <div className="between gap-50">
        <div>
          <h3 className="verde">
            {activo ? "Marcar mi perfil como inactivo" : "Reactivar mi perfil"}
          </h3>
          <p>
            Puedes marcar tu perfil como inactivo si no vas a usar la plataforma
            temporalmente.
          </p>
        </div>
        <button
          type="button"
          className="toggle-icon"
          onClick={handleToggle}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          {activo ? (
            <FaToggleOn size={32} className="verde" />
          ) : (
            <FaToggleOff size={32} color="#8E151D" />
          )}
        </button>
      </div>
    </div>
  );
};

export default ActivarDesactivarTecnicos;
